import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles(theme => ({
  container: {
    width: "100%",
    color: "#fff",
    display: "flex",
    justifyContent: "space-between",
    padding: theme.spacing(2),
    backgroundColor: "#131313",
    borderRadius: "12px",
    [theme.breakpoints.down("sm")]: {
      padding: "16px",
    },
  },
  contentWrapper: {
    maxWidth: "700px",
    width: "100%",
    paddingRight: "40px",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: 12,
    flexWrap: "wrap",
    columnGap: "10px",
    minWidth: "100%",
    [theme.breakpoints.down("sm")]: {
      padding: "0px",
      paddingRight: "0px",
    },
  },
  header: {
    color: "#f06ec4",
    fontSize: "24px",
    fontWeight: 600,
    marginBottom: theme.spacing(4),
    paddingBottom: theme.spacing(1),
    borderBottom: "1px solid #363636",
  },
  profileSection: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(2),
    marginBottom: theme.spacing(3),
    marginLeft: "82px",
    [theme.breakpoints.down("sm")]: {
      margin: "10px 0 0 0",
    },
  },
  profileImage: {
    width: "48px",
    height: "48px",
    borderRadius: "50%",
    objectFit: "cover",
    border: "2px solid #f06ec4",
  },
  profileTextContainer: {
    display: "flex",
    flexDirection: "column",
  },
  creatorText: {
    color: "#fff",
    fontSize: "16px",
    fontWeight: 600,
    marginBottom: "0px",
  },
  creatorTextHelp: {
    color: "#FE5A97",
    fontSize: "13px",
    fontWeight: 600,
    marginBottom: "0px",
  },
  changePhotoText: {
    color: "#f06ec4",
    fontSize: "14px",
    fontWeight: 400,
    background: "none",
    border: "none",
    padding: 0,
    cursor: "pointer",
    textTransform: "none",
    "&:hover": {
      textDecoration: "underline",
      background: "none",
    },
  },
  formRow: {
    display: "flex",
    alignItems: "flex-start",
    marginBottom: theme.spacing(2),
    justifyContent: "center",
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
    },
  },
  formRowNamme: {
    display: "flex",
    alignItems: "flex-start",
    flexDirection: "column",
    marginBottom: theme.spacing(2),
    justifyContent: "center",
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
      marginTop: "20px",
    },
  },
  formRowNammeContainer: {
    display: "flex",
    [theme.breakpoints.down("sm")]: {
      columnGap: "10px",
    },
  },
  label: {
    width: "90px",
    paddingTop: "10px",
    color: "#fff",
    fontSize: "16px",
    fontWeight: 500,
    textAlign: "right",
    marginRight: "8px",
    [theme.breakpoints.down("sm")]: {
      textAlign: "left",
      width: "55px",
    },
  },
  fieldContainer: {
    flex: 1,
    width: "100%",
  },
  fieldContainerHelp: {
    flex: 1,
    width: "100%",
    [theme.breakpoints.down("sm")]: {
      MaxWidth: "130px",
    },
  },
  inputField: {
    width: "100%",
    "& .MuiInputBase-root": {
      color: "#fff",
      fontSize: "16px",
      backgroundColor: "#1a1a1a",
      borderRadius: "4px",
    },
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: "#EDECED",
      },
      "&:hover fieldset": {
        borderColor: "#f06ec4",
      },
      "&.Mui-focused fieldset": {
        borderColor: "#f06ec4",
      },
    },
    "& .MuiSelect-icon": {
      color: "#fff",
    },
  },
  inputFieldHelp: {
    width: "100%",
    "& .MuiInputBase-root": {
      color: "#fff",
      fontSize: "16px",
      backgroundColor: "#1a1a1a",
      borderRadius: "4px",
    },
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: "#EDECED",
      },
      "&:hover fieldset": {
        borderColor: "#f06ec4",
      },
      "&.Mui-focused fieldset": {
        borderColor: "#f06ec4",
      },
    },
    "& .MuiSelect-icon": {
      color: "#fff",
    },
    [theme.breakpoints.down("sm")]: {
      width: "115px",
    },
  },
  helperText: {
    color: "#FFFFFF",
    fontSize: "12px",
    marginTop: "4px",
  },
  helperTextHelp: {
    color: "#FFFFFF",
    fontSize: "12px",
    marginTop: "4px",
    marginLeft: "100px",
    [theme.breakpoints.down("sm")]: {
      marginLeft: "0",
    },
  },
  pinkText: {
    color: "#f06ec4",
    textDecoration: "none",
    "&:hover": {
      textDecoration: "underline",
      color: "#f06ec4",
    },
    "&:focus": {
      textDecoration: "none",
    },
  },
  pinkForWord: {
    color: "#f06ec4",
    textDecoration: "none",
  },
  sectionTitle: {
    color: "#fff",
    fontSize: "16px",
    fontWeight: 600,
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(1),
    marginLeft: "100px",
    [theme.breakpoints.down("sm")]: {
      marginLeft: "0",
    },
  },
  sectionDescription: {
    color: "#FFFFFF",
    fontSize: "12px",
    marginBottom: theme.spacing(2),
    marginLeft: "100px",
    [theme.breakpoints.down("sm")]: {
      marginLeft: "0",
    },
  },
  bioCounter: {
    color: "#999999",
    fontSize: "12px",
    marginTop: "4px",
    textAlign: "right",
  },
  checkbox: {
    color: "#f06ec4",
    marginRight: 0,
    "&.Mui-checked": {
      color: "#f06ec4",
    },
    verticalAlign: "middle",
  },
  checkboxLabel: {
    color: "#fff",
    fontWeight: 500,
    fontSize: "16px",
    display: "inline",
    verticalAlign: "middle",
  },
  checkboxWrapper: {
    display: "inline-flex",
    alignItems: "center",
    paddingTop: "10px",
  },
  submitButton: {
    backgroundColor: "#f06ec4",
    color: "white",
    borderRadius: "8px",
    padding: "8px 16px",
    float: "right",
    marginTop: theme.spacing(2),
    textTransform: "none",
    fontSize: "14px",
    "&:hover": {
      backgroundColor: "#d45ca5",
    },
  },
  formRowMessages: {
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "flex-start",
    marginLeft: "30px",
    [theme.breakpoints.down("sm")]: {
      display: "none",
    },
  },
  labelMessages: {
    color: "#fff",
    fontSize: "16px",
    fontWeight: 500,
    width: "120px",
  },
  messageContainer: {
    display: "flex",
    alignItems: "center",
    gap: "2px",
  },
  allowText: {
    color: "#fff",
    fontSize: "16px",
    fontWeight: 500,
    marginLeft: 0,
  },
  section: {
    marginBottom: "4px",
    backgroundColor: "#131313",
    padding: "39px 32px 0 8px",
    borderRadius: theme.spacing(1),
    color: "white",
    [theme.breakpoints.down("sm")]: {
      padding: "14px 32px 0 24px",
    },
  },
  passwordText: {
    color: "#F0F0F0",
    marginBottom: "20px",
    fontSize: "14px",
  },
  controlSection: {
    marginTop: theme.spacing(3),
  },
  controlTitle: {
    color: "#f06ec4",
    marginBottom: theme.spacing(2),
    marginTop: theme.spacing(3),
    fontWeight: 500,
    fontSize: "14px",
    [theme.breakpoints.down("sm")]: {
      marginTop: 0,
    },
  },
  settingRow: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "8px",
    padding: "8px 0 ",
    flexDirection: "row",
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
      alignItems: "flex-start",
    },
  },
  settingLabelContainer: {
    display: "flex",
    alignItems: "center",
  },
  settingLabel: {
    color: "white",
    fontSize: "16px",
    marginBottom: "8px",
  },
  settingText: {
    color: "#A3A3A3",
    fontSize: "14px",
    fontWeight: 400,
  },
  toggleButtonGroup: {
    display: "flex",
    borderRadius: "6px",
    overflow: "hidden",
    backgroundColor: "#1F1F1F",
    [theme.breakpoints.down("sm")]: {
      width: "100%",
    },
  },
  activeButton: {
    backgroundColor: "#FE5A97",
    color: "white",
    borderRadius: "6px",
    padding: "6px 9px",
    minWidth: "80px",
    textTransform: "none",
    fontSize: "14px",
    "&:hover": {
      backgroundColor: "#FF68D5",
    },
    "&:focus": {
      outline: "none",
      boxShadow: "none",
    },
    [theme.breakpoints.down("md")]: {
      minWidth: "154px",
    },
    [theme.breakpoints.down("sm")]: {
      minWidth: "50%",
    },
  },
  inactiveButton: {
    backgroundColor: "#1F1F1F",
    color: "white",
    borderRadius: "6px",
    padding: "6px 9px",
    minWidth: "80px",
    textTransform: "none",
    fontSize: "14px",
    "&:hover": {
      backgroundColor: "#1F1F1F",
    },
    "&:focus": {
      outline: "none",
      boxShadow: "none",
    },
    [theme.breakpoints.down("md")]: {
      minWidth: "154px",
    },
    [theme.breakpoints.down("sm")]: {
      minWidth: "50%",
    },
  },
  selectControl: {
    width: "180px",
    height: "44px",
  },
  select: {
    backgroundColor: "#131313",
    color: "white",
    height: "44px",

    borderRadius: "30px",
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: "#363636",
      borderRadius: "30px",
    },
    "&:hover .MuiOutlinedInput-notchedOutline": {
      borderColor: "#666666",
    },
    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: "#f06ec4",
    },
    "& .MuiSelect-icon": {
      color: "#f06ec4",
    },
  },
  menuPaper: {
    backgroundColor: "#222222",
    color: "white",
    borderRadius: "4px",
  },
  menuItem: {
    "&:hover": {
      backgroundColor: "#363636",
    },
    "&.Mui-selected": {
      backgroundColor: "#444444",
    },
    "&.Mui-selected:hover": {
      backgroundColor: "#505050",
    },
  },

  dividerTop: {
    height: "1px",
    backgroundColor: "#232323",
    width: "100%",
    marginBottom: theme.spacing(2),
  },

  divider: {
    height: "1px",
    backgroundColor: "#EAECF0",
    width: "100%",
    marginTop: "118px",
    marginBottom: theme.spacing(2),
    [theme.breakpoints.down("sm")]: {
      display: "none",
    },
  },
  buttonContainer: {
    display: "flex",
    justifyContent: "flex-end",
    marginTop: theme.spacing(2),
    gap: "10px",
  },
  cancelButton: {
    color: "#344054",
    width: "75px",
    border: "1px solid #363636",
    height: "40px",
    fontSize: "14px",
    fontWeight: 600,
    borderRadius: "8px",
    textTransform: "none",
    backgroundColor: "#FFFFFF",
    "&:hover": {
      backgroundColor: "#e0e0e0",
    },
    [theme.breakpoints.down("sm")]: {
      display: "none",
    },
  },
  saveButton: {
    color: "white",
    backgroundColor: "#f06ec4",
    width: "75px",
    border: "1px solid #363636",
    height: "40px",
    fontSize: "14px",
    fontWeight: 600,

    "&:hover": {
      backgroundColor: "#d45ca5",
    },
    textTransform: "none",
    padding: "8px 16px",
    borderRadius: "8px",
  },
  deactivateLink: {
    color: "#f06ec4",
    fontSize: "14px",
    marginTop: theme.spacing(2),
    cursor: "pointer",
    textAlign: "left",
    "&:hover": {
      textDecoration: "underline",
    },
  },
}));
